define('modules/form_editor/views/preview_custom_date',['require','exports','module','./preview_base','i18n','ldsh!../templates/preview_custom_date'],function(require, exports, module){
  "use strict";
  var PreviewBase = require("./preview_base"),
      i18n = require("i18n");

  var FIRST_DAY = 1,
      LAST_DAY = 31,
      FIRST_YEAR = 1900,
      MONTHS = ["january", "february", "march", "april", "may",
        "june", "july", "august", "september", "october", "november", "december"];

  module.exports = PreviewBase.extend({
    template: require("ldsh!../templates/preview_custom_date"),
    className: "form-group ed-panel-item form-group-col date-group",
    _renderFirstOption: function(type) {
      if (this.model.get("firstOptionInvalid")) {

        return $("<option />")
          .attr("value", "")
          .text(this.localize("formEditor.select" + type));
      }
    },

    _renderYear: function(selector) {
      var end = this._getDateYearEnd();
      selector
        .append(this._renderFirstOption("Year"))
        .append(this._getDateYearOptions(FIRST_YEAR, end));
    },

    _getDateYearEnd: function() {
      var currentYear = (new Date()).getFullYear(),
          ageLimit = this.model.get("ageLimit");

      return ageLimit ? currentYear - ageLimit : currentYear + 1;
    },

    _getDateYearOptions: function(yearBegin, yearEnd) {
      var options = '';

      while(yearEnd >= yearBegin) {
        options += "<option value=" + yearEnd + ">" + yearEnd-- + "</option>";
      }

      return options;
    },

    _renderMonth: function(selector) {
      selector.append(this._renderFirstOption("Month"));
      _.each(MONTHS, function (month, index) {
        var translation = this.localize("formEditor.months." + month),
            monthNum = index + 1;
        if (this.model.get("fillWithZero")) monthNum = ('00' + monthNum).slice(-2);
        selector.append("<option value=" + monthNum + ">" + translation + "</option>");
      }, this);
    },

    _renderDay: function(selector) {
      selector.append(this._renderFirstOption("Day"));
      var start = FIRST_DAY;
      while (start <= LAST_DAY) {
        var dayNum = start;
        this.model.get("fillWithZero") && (dayNum = ('00' + dayNum).slice(-2));
        selector.append("<option value=" + dayNum + ">" + dayNum + "</option>");
        start++;
      }
    },

    onRender: function(){
      module.exports.__super__.onRender.apply(this, arguments);
      var order = this.model.get("dateOrder").split("/");

      _.each(order, function(item, index){
        var renderMethod = this["_render" + item];
        if (renderMethod) {
          renderMethod.call(this, this.$(".js-select-"+index));
        }
      }, this);

      this.$el.i18n();
    },

    helpers: function () {
      return {
        ageLimit: this.model.get("ageLimit"),
        itemSuffix: this.model.get("dateOrder").toLowerCase().split("/"),
        invalidDateMessage: this.model.getFormEditorMessage(
          "invalidDateMessage", {
            label: this.model.get("labelText")
          }
        ),
        invalidDateAgeLimitMessage: this.model.getFormEditorMessage(
          "invalidDateAgeLimitMessage", {
            label: this.model.get("labelText"),
            ageLimit: this.model.get("ageLimit")
          }
        )
      };
    }
  });
});

